/* ============================================
   Shared LifeAdmin helpers — date math, greetings.
   Tab-specific data lives in todayData.js / etc.
   ============================================ */

const MONTH_NAMES = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

// Local date as YYYY-MM-DD (NOT UTC — "today" should be the user's today,
// even if they're traveling timezones).
export function todayLocalDateStr() {
  return localDateStr(new Date());
}

export function localDateStr(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function formatLongDate(dateStr) {
  if (!dateStr) return '';
  // Parse YYYY-MM-DD as local date (not UTC) by appending T00:00:00
  const d = new Date(`${dateStr}T00:00:00`);
  return `${MONTH_NAMES[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
}

export function formatShortDate(dateStr) {
  if (!dateStr) return '';
  const d = new Date(`${dateStr}T00:00:00`);
  return `${MONTH_NAMES[d.getMonth()].slice(0, 3)} ${d.getDate()}`;
}

export function getGreeting(d = new Date()) {
  const h = d.getHours();
  if (h < 5)  return 'Good evening';
  if (h < 12) return 'Good morning';
  if (h < 17) return 'Good afternoon';
  return 'Good evening';
}

export function firstName(user) {
  if (!user) return 'friend';
  const name = user.user_metadata?.full_name || user.email?.split('@')[0] || 'friend';
  return String(name).split(' ')[0];
}
